<template>
    <v-container>
        <v-row class="mx-1 mb-5 mt-1 heading-title">
            Alert Preferences
        </v-row>

        <v-row class="mx-1 mb-5 mt-1 content">
            {{ ticketAlertText }}
        </v-row>

        <v-col cols="12">
            <v-simple-table
                class="table"
            >
                <thead
                    style="background-color:#F5F7FA;"
                >
                    <tr>
                        <th class="font-weight-bold text-left">
                            Ticket Type
                        </th>
                        <th class="font-weight-bold text-left">
                            In App
                        </th>
                        <th class="font-weight-bold text-left">
                            Email
                        </th>
                        <th
                            v-if="ticketAlertSms"
                            class="font-weight-bold text-left"
                        >
                            SMS/TEXT
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="item in items"
                        :key="item.name"
                    >
                        <td>
                            {{ item.name }}
                        </td>
                        <td>
                            <v-checkbox
                                v-model="item.inapp.value"
                                color="primary"
                                :ripple="false"
                                hide-details
                                class="mt-0"
                            />
                        </td>
                        <td>
                            <v-checkbox
                                v-model="item.email.value"
                                color="primary"
                                :ripple="false"
                                hide-details
                                class="mt-0"
                            />
                        </td>
                        <td v-if="ticketAlertSms">
                            <v-checkbox
                                v-model="item.sms.value"
                                :value="false"
                                color="primary"
                                :ripple="false"
                                hide-details
                                class="mt-0"
                            />
                        </td>
                    </tr>
                </tbody>
            </v-simple-table>
        </v-col>
        <v-row class="mx-1 my-6 content">
            Ticket UI Alerts may be escalated to another User if they are not dismissed within the specified timeout period. Indicate the User (if any) that should receive the escalated alert and the amount of time before that escalation occurs. If a ticket is being escalated to a Locator account, then the ticket will be re-assigned to that user.
        </v-row>

        <v-row class="mx-1 mb-2">
            <v-col class="col col-md-6 p-0">
                <v-select
                    v-model="TICKET_ALERT_ESCALATE_TO"
                    outlined
                    dense
                    label="Escalate To"
                    :items="users"
                    item-text="displayName"
                    item-value="uid"
                />
            </v-col>
        </v-row>

        <v-row class="mx-1 mb-2">
            <v-col class="col col-md-6 p-0">
                <v-select
                    v-model="TICKET_ALERT_ESCALATE_TIMEOUT"
                    outlined
                    dense
                    label="Escalation Timeout"
                    :items="escalationTimeout"
                    item-text="name"
                    item-value="value"
                />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import webtmsBackend from '@/services/webtmsBackend';
import { getUserOption } from '../../../utils/options';
import { hasPermission } from '@/utils/permissions';
import { isTruthy } from '@/utils/isTruthy';
import { guidEqual } from '@/utils/guid.js';

export default {
    name: 'AlertPreferences',
    data: () => ({
        TICKET_ALERT_ESCALATE_TO: '',
        TICKET_ALERT_ESCALATE_TIMEOUT: '15',
        escalationTimeout: [
            { name: '15 Minutes', value: '15' },
            { name: '30 Minutes', value: '30' },
            { name: '45 Minutes', value: '45' },
            { name: '1 Hour', value: '60' },
            { name: '2 Hour', value: '120' },
            { name: '3 Hour', value: '180' },
            { name: '4 Hour', value: '240' },
            { name: '8 Hour', value: '480' },
            { name: '12 Hour', value: '720' },
        ],
        ticketAlertSms: hasPermission('TICKET_ALERTS--SMS') 
    }),
    computed: {
        getUserDetails() {
            return this.$store.getters.user;
        },
        useroptions() {
            return this.$store.getters.alertPreferences;
        },
        getCompanyUsers() {
            return this.$store.getters.companyUsers;
        },
        getEditUser() {
            return this.$store.getters.editUser;
        },
        users() {
            let users = this.getCompanyUsers
                .filter(item => item.ingroup === 'Administrator' || item.ingroup === 'Dispatcher')
                .reduce((acc, curr) => {
                    if(!acc[curr.ingroup]) {
                        acc[curr.ingroup] = [{ header: curr.ingroup }];
                    }
                    curr.displayName = `${curr.account} (${curr.name})`;
                    acc[curr.ingroup].push(curr);
                    return acc;
                }, {});
            users = Object.values(users).flat();
            users.unshift({ displayName: 'Do Not Escalate', uid: '' });
            return users;
        },
        items() {
            return [
                {
                    name: 'Emergency',
                    inapp: { option: 'TICKET_ALERT_EMERGENCY_UI', value: this.getOptionValue('TICKET_ALERT_EMERGENCY_UI') },
                    email: { option: 'TICKET_ALERT_EMERGENCY_EMAIL', value: this.getOptionValue('TICKET_ALERT_EMERGENCY_EMAIL') },
                    sms: { option: 'TICKET_ALERT_EMERGENCY_SMS', value: this.getOptionValue('TICKET_ALERT_EMERGENCY_SMS') },
                },
                {
                    name: 'Damage',
                    inapp: { option: 'TICKET_ALERT_DAMAGE_UI', value: this.getOptionValue('TICKET_ALERT_DAMAGE_UI') },
                    email: { option: 'TICKET_ALERT_DAMAGE_EMAIL', value: this.getOptionValue('TICKET_ALERT_DAMAGE_EMAIL') },
                    sms: { option: 'TICKET_ALERT_DAMAGE_SMS', value: this.getOptionValue('TICKET_ALERT_DAMAGE_SMS') },
                },
                {
                    name: 'Design',
                    inapp: { option: 'TICKET_ALERT_DESIGN_UI', value: this.getOptionValue('TICKET_ALERT_DESIGN_UI') },
                    email: { option: 'TICKET_ALERT_DESIGN_EMAIL', value: this.getOptionValue('TICKET_ALERT_DESIGN_EMAIL') },
                    sms: { option: 'TICKET_ALERT_DESIGN_SMS', value: this.getOptionValue('TICKET_ALERT_DESIGN_SMS') },
                },
                {
                    name: 'Cancel',
                    inapp: { option: 'TICKET_ALERT_CANCEL_UI', value: this.getOptionValue('TICKET_ALERT_CANCEL_UI') },
                    email: { option: 'TICKET_ALERT_CANCEL_EMAIL', value: this.getOptionValue('TICKET_ALERT_CANCEL_EMAIL') },
                    sms: { option: 'TICKET_ALERT_CANCEL_SMS', value: this.getOptionValue('TICKET_ALERT_CANCEL_SMS') },
                },
                {
                    name: 'Late',
                    inapp: { option: 'TICKET_ALERT_LATE_UI', value: this.getOptionValue('TICKET_ALERT_LATE_UI') },
                    email: { option: 'TICKET_ALERT_LATE_EMAIL', value: this.getOptionValue('TICKET_ALERT_LATE_EMAIL') },
                    sms: { option: 'TICKET_ALERT_LATE_SMS', value: this.getOptionValue('TICKET_ALERT_LATE_SMS') },
                },
                {
                    name: 'On Escalated',
                    inapp: { option: 'TICKET_ALERT_ESCALATED_UI', value: this.getOptionValue('TICKET_ALERT_ESCALATED_UI') },
                    email: { option: 'TICKET_ALERT_ESCALATED_EMAIL', value: this.getOptionValue('TICKET_ALERT_ESCALATED_EMAIL') },
                    sms: { option: 'TICKET_ALERT_ESCALATED_SMS', value: this.getOptionValue('TICKET_ALERT_ESCALATED_SMS') },
                },
            ];
        },
        ticketAlertText() {
            let alertText = 'Ticket Alerts are generated for certain ticket types. The UI (User Interface) alert will display an alert notification on the Web homepage that must be dismissed. You can also include an E-Mail alert to be sent.';

            if (this.ticketAlertSms) {
                alertText = 'Ticket Alerts are generated for certain ticket types. The UI (User Interface) alert will display an alert notification on the Web homepage that must be dismissed. You can also include an E-Mail and SMS alert to be sent.';
            } 
            return  alertText;
        },
    },
    created() {
        this.setFormData();
    },
    methods: {
        getOptionValue(optionName) {
            let value = '0';            
            if(this.$route.query.id) {
                // we have an id so we are editing 
                if(this.getEditUser) {
                    // we have user information so we are editing a user
                    if(this.getEditUser.userOptions) {
                        // we have user options so we are editing a user option
                        let userOption = this.getEditUser.userOptions.find(option => optionName === option.option);
                        // we have a user option so we can get the value
                        if(userOption) {
                            value = isTruthy(userOption.value);
                        }                        
                        return value;
                    }
                } 
            } else {
                // we are creating a new user so we need to get the default value
                if(this.getEditUser) {                    
                    if(this.getEditUser.userOptions) {
                        let userOption = this.getEditUser.userOptions.find(option => optionName === option.option);
                        if(userOption) {
                            value = isTruthy(userOption.value);
                            return value;
                        } else {
                            value = getUserOption(optionName);
                            return isTruthy(value);
                        }
                    } else {
                        value = getUserOption(optionName);
                        return isTruthy(value);
                    }
                }
            }
        },
        async updateAlertSettings() {
            let options = [];
            this.items.forEach((item)=> {
                options.push({option: item.inapp.option, value: item.inapp.value});
                options.push({option: item.email.option, value: item.email.value});
                options.push({option: item.sms.option, value: item.sms.value}); 
            });
            options.push({ option: 'TICKET_ALERT_ESCALATE_TO', value: this.TICKET_ALERT_ESCALATE_TO });
            options.push({ option: 'TICKET_ALERT_ESCALATE_TIMEOUT', value: this.TICKET_ALERT_ESCALATE_TIMEOUT });
            if(this.getEditUser) {
                options.push({ option: 'EMAIL_TICKET_FORMAT', value: this.getEditUser.EMAIL_TICKET_FORMAT });
            }

            options.push({ option: 'RECEIVE_OVERDUE_NOTIFICATION', value: this.getEditUser.RECEIVE_OVERDUE_NOTIFICATION });
            options.push({ option: 'RECEIVE_COMPANY_EOD_AUDIT', value: this.getEditUser.RECEIVE_COMPANY_EOD_AUDIT });
            options.push({ option: 'RECEIVE_COMPANY_EOD_REPORT', value: this.getEditUser.RECEIVE_COMPANY_EOD_REPORT });
            options.push({ option: 'RECEIVE_SYSTEM_SOD', value: this.getEditUser.RECEIVE_SYSTEM_SOD });
            options.push({ option: 'RECEIVE_SYSTEM_EOD', value: this.getEditUser.RECEIVE_SYSTEM_EOD });
            options.push({ option: 'RECEIVE_SYSTEM_CHECK_ERRORS', value: this.getEditUser.RECEIVE_SYSTEM_CHECK_ERRORS });
            options.push({ option: 'RECEIVE_OVERDUE_NOTIFICATION_INTERVAL', value: this.getEditUser.RECEIVE_OVERDUE_NOTIFICATION_INTERVAL });
            options.push({ option: 'ALTERNATE_LOCATOR', value: this.getEditUser.ALTERNATE_LOCATOR });
            options.push({ option: 'ASSIGNED_TICKET_LIMIT', value: this.getEditUser.ASSIGNED_TICKET_LIMIT });
            options.push({ option: 'ASSIGNMENT_ON_HOLD', value: this.getEditUser.ASSIGNMENT_ON_HOLD });
            options.push({ option: 'FORCE_ALTERNATE_LOCATOR', value: this.getEditUser.FORCE_ALTERNATE_LOCATOR });
            options.push({ option: 'EMAIL_ASSIGNED_TICKETS', value: this.getEditUser.EMAIL_ASSIGNED_TICKETS });
            options.push({ option: 'VACATION1', value: this.getEditUser.VACATION1 });
            options.push({ option: 'VACATION2', value: this.getEditUser.VACATION2 });
            options.push({ option: 'VACATION3', value: this.getEditUser.VACATION3 });
            options.push({ option: 'VACATION4', value: this.getEditUser.VACATION4 });
            options.push({ option: 'VACATION5', value: this.getEditUser.VACATION5 });

            if(this.getEditUser) {
                this.$store.commit('SET_EDIT_USER', { 
                    ...this.getEditUser,
                    userOptions: options
                });
                // if we are editing the logged user we need to update the userOptions in the store                
                if(guidEqual(this.getEditUser?.uid, this.$store.state.user?.uid)) {
                    let userOptions = this.getEditUser.userOptions;
                    let newUserOptions = [];
                    if(userOptions) {
                        userOptions.forEach((option) => {
                            newUserOptions.push([ option.option, option.value ]);                           
                        });                        
                        await this.$store.dispatch('updateUserOptions', newUserOptions);
                    }                   
                }
            }
        },
        convertToBoolean(value) {
            if (value === '1') {
                return true;
            }
            return false;
        },
        convertToBit(value) {
            if (value) {
                return '1';
            }
            return '0';
        },
        setFormData() {
            if(this.$route.query.id) { 
                this.isEditUser = true;
            }
            if(this.getEditUser) {
                if(this.getEditUser.userOptions) {
                    this.getEditUser.userOptions.map(item => {
                        if(item.option === 'TICKET_ALERT_ESCALATE_TO') {
                            this.TICKET_ALERT_ESCALATE_TO = item.value;
                        }
                        if(item.option === 'TICKET_ALERT_ESCALATE_TIMEOUT') {
                            this.TICKET_ALERT_ESCALATE_TIMEOUT = item.value;
                        }
                    });
                }
            }
        },
        async editUser() {
            try {
                this.updateAlertSettings();
                let result = await webtmsBackend.updateUser({uid: this.$route.query.id, ...this.getEditUser});
                if(result.status === 'OK') {
                    if(this.getEditUser.account === this.getUserDetails.account) {
                        const getUserResult = await webtmsBackend.getUserObject(this.getUserDetails.uid);
                        this.$store.commit('SET_USER', getUserResult);                        
                    }
                    this.$store.dispatch('setSnackbar', { text: `User account "${result.user.name}" updated successfully.` });
                    this.$store.commit('SET_EDIT_USER', null);                   
                    this.$router.push('users');
                }
                if(result.err) {
                    this.$store.dispatch('setSnackbar', { color:'error', text: result.err });
                }
            } catch(error) {
                this.$store.dispatch('setSnackbar', { color:'error', text: error });
            }
        }
    }
};
</script>
<style>
    .heading-title {
        font-weight: 500;
        font-size: 16px;
        color: #35383F;
    }
    .sub-heading-title {
        font-weight: 500;
        font-size: 14px;
        color: #35383F;
    }
    .content {
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: 0.004em;
        color: #35383F;
    }
</style>